module.exports = __webpack_public_path__ + "static/media/plan-C5-desktop-en.00cb0ffd.png";